module.exports = require("./../../_gen/starling/display/Canvas");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Canvas.js
// module id = 163
// module chunks = 0